<template>
<div class="scene" data-53000="top: 100%; display: block;" data-54000="top: 0%; display: block;" data-64000="top: 0%; display: block;" data-65000="top: -100%; display: block;"  style="top: 100%; display: block;">
    <div class="section6">
        <div class="section6-inner">
            <img class="sixground" src="static/fog/section6/ground.png" data-53000="bottom: -7%; left: -30%; display: block;" style="bottom: -7%; left: -30%; display: block;">
            <img class="sixtwofeature" src="static/fog/section6/twofeature.png" data-54000="top: -100%; display: block;"  data-54500="top: 70%; display: block;" style="top: 0%;display: block;">
            <img class="sixlefttree" src="static/fog/section6/lefttree.png" data-54500="left: -100%; display: block;"  data-55000="left: 5%; display: block;" style="left: 0%;display: block;">
            <img class="sixrighttree" src="static/fog/section6/righttree.png" data-54500="right: -100%; display: block;"  data-55000="right: 5%; display: block;" style="right: 0%;display: block;">
            <img class="sixleftboard" src="static/fog/section6/leftboard.png" data-55000="bottom: -100%; display: block;"  data-55500="bottom: 15%; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft1" src="static/fog/section6/left1.png" data-55500="opacity: 0; display: block;"  data-55700="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft2" src="static/fog/section6/left2.png" data-56500="opacity: 0; display: block;"  data-56700="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft3" src="static/fog/section6/left3.png" data-55900="opacity: 0; display: block;"  data-56100="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft4" src="static/fog/section6/left4.png" data-56300="opacity: 0; display: block;"  data-56500="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft5" src="static/fog/section6/left5.png" data-56900="opacity: 0; display: block;"  data-57100="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft6" src="static/fog/section6/left6.png" data-55700="opacity: 0; display: block;"  data-55900="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft7" src="static/fog/section6/left7.png" data-56700="opacity: 0; display: block;"  data-56900="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixleft8" src="static/fog/section6/left8.png" data-56100="opacity: 0; display: block;"  data-56300="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixrightboard" src="static/fog/section6/rightboard.png" data-57500="bottom: -100%; display: block;"  data-58000="bottom: 15%; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright1" src="static/fog/section6/right1.png" data-58000="opacity: 0; display: block;"  data-58200="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright2" src="static/fog/section6/right2.png" data-59000="opacity: 0; display: block;"  data-59200="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright3" src="static/fog/section6/right3.png" data-58400="opacity: 0; display: block;"  data-58600="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright4" src="static/fog/section6/right4.png" data-58800="opacity: 0; display: block;"  data-59000="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright5" src="static/fog/section6/right5.png" data-59400="opacity: 0; display: block;"  data-59600="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright6" src="static/fog/section6/right6.png" data-58200="opacity: 0; display: block;"  data-58400="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright7" src="static/fog/section6/right7.png" data-59200="opacity: 0; display: block;"  data-59400="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixright8" src="static/fog/section6/right8.png" data-58600="opacity: 0; display: block;"  data-58800="opacity: 1; display: block;" style="bottom: 0%;display: block;">
            <img class="sixwhiteboard" src="static/fog/section6/whiteboard.png" data-60000="top: -100%; display: block;"  data-60500="top: 0%; display: block;" data-62700="top: 0%; display: block;" data-63200="top: -100%; display: block;" style="top: -100%;display: block;">
            <p class="sixtext1" data-60000="top: -100%; display: block;" data-60500="top: 20%; display: block;" data-60800="top: 20%; display: block;" data-60801="top: 20%; display: none;" style="top: 20%; display: block;">所有勒索者的共通特質是<highlight>長期感到憂慮及匱乏、喪失安全感及自信心</highlight>，為了抵禦不確定感和壓力的侵蝕，進而衍生出勒索的手段。</p>
            <p class="sixtext1" data-60800="top: 18%; display: none;" data-60900="top: 18%; display: block;" data-61200="top: 18%; display: block;" data-61201="top: 18%; display: none;" style="top: 18%; display: none;" >他們很少真心想要恐嚇，只不過是想藉此尋求安全感及掌控權。當我們完全附和勒索者的要求時，他們會覺得自己極有影響力，這時情緒勒索就成了他們抵禦恐懼的最佳利器。</p>
            <p class="sixtext1" data-61100="top: 18%; display: none;" data-61200="top: 25%; display: block;" data-61500="top: 25%; display: block;" data-61501="top: 18%; display: none;" style="top: 25%; display: none;">情緒勒索你情我願，如果沒有你的默許，這場交易不會完成！</p>
            <p class="sixtext1" data-61400="top: 18%; display: none;" data-61500="top: 20%; display: block;" data-61800="top: 20%; display: block;" data-61801="top: 18%; display: none;" style="top: 20%; display: none;" >被勒索者不夠愛自己、不夠重視自己的感受、總是害怕會失去關係…，而努力維持關係、希望可以換到對方的看重和愛，殊不知，長期的勒索反倒換來了害怕與傷害。</p>
            <p class="sixtext1" data-61700="top: 18%; display: none;" data-61800="top: 25%; display: block;" data-62100="top: 25%; display: block;" data-62101="top: 18%; display: none;" style="top: 25%; display: none;">這兩大類的特質有個共通性---<highlight>脆弱的自我</highlight></p>
            <p class="sixtext1" data-62000="top: 18%; display: none;" data-62100="top: 20%; display: block;" data-62400="top: 20%; display: block;" data-62401="top: 18%; display: none;" style="top: 20%; display: none;">基於種種相似的核心特質，勒索者與被勒索者的攻守位置其實是會交換的！很多人有時在一段關係中扮演勒索者的角色，而在另一段關係中卻扮演被勒索者的角色。</p>
            <p class="sixtext1" data-62300="top: 18%; display: none;" data-62400="top: 20%; display: block;" data-62700="top: 20%; display: block;" data-63200="top: -100%; display: block;" style="top: 20%; display: none;">又或者，一段關係中的兩人互相扮演著勒索者與被勒索者，彼此相互勒索。這些情況都是可能的。</p>
        </div>
    </div>
</div>
</template>

<script>
export default {
    data() {
        return {
            step6:1,
        }
    },
    methods:{
        prev6() {
            this.step6--;
        },
        next6() {
            this.step6++;
        }
    }
}
</script>

<style>
.section6{
    height: 100%;
    background: #9CE1BD;
}

.section6-inner{
    width: 1000px;
    height: 100%;
    margin: 0 auto;
    position: relative;
}
.sixtwofeature{
    height: 23%;
    left: 42%;
}
.sixlefttree{
    height: 95%;
    top: 0%;
}
.sixrighttree{
    height: 95%;
    top: 0%;
}
.sixleftboard{
    height: 8%;
    left: 8%;
}
.sixrightboard{
    height: 8%;
    right: 13%;
}

.sixleft1{
    height: 12%;
    top: 3%;    
    left: 14%;
}
.sixleft2{
    height: 12%;
    top: 10%;    
    left: 4%;
}
.sixleft3{
    height: 9%;
    top: 16%;    
    left: 15%;
}
.sixleft4{
    height: 11%;
    top: 22%;    
    left: 23%;
}
.sixleft5{
    height: 11%;
    top: 25%;    
    left: 1%;
}
.sixleft6{
    height: 10%;
    top: 40%;    
    left: 3%;
}
.sixleft7{
    height: 10%;
    top: 49%;    
    left: 16%;
}
.sixleft8{
    height: 10%;
    top: 60%;    
    left: 5%;
}
.sixright1{
    height: 12%;
    top: 3%;    
    right: 9%;
}
.sixright2{
    height: 12%;
    top: 10%;    
    right: 20%;
}
.sixright3{
    height: 9%;
    top: 16%;    
    right: 10%;
}
.sixright4{
    height: 11%;
    top: 22%;    
    right: 2%;
}
.sixright5{
    height: 11%;
    top: 25%;    
    right: 24%;
}
.sixright6{
    height: 10%;
    top: 40%;    
    right: 22%;
}
.sixright7{
    height: 10%;
    top: 49%;    
    right: 9%;
}
.sixright8{
    height: 10%;
    top: 60%;    
    right: 19%;
}
.sixwhiteboard{
    height: 48%;
    left: 31.5%;
}
.sixtext1{
    position: absolute;
    width: 320px;
    left: 34%;
}
.twoarrowpre{
    height: 3%;
    right: 60%;
}

.twoarrownext{
    height: 3%;
    right: 35%;
}
</style>


// WEBPACK FOOTER //
// src/components/pages/fog/Section6.vue